import {BaseService} from './baseService.js';
import {Service} from './service.js';

/**
 * Handles help
 */
export class HelpService extends BaseService {
	
	static get properties() {		
		return {			
		};
	}
	
	constructor() {	
		super();
	}
	
	async getAllHelp() {
		var data = await this.makeGETRequest('/api/resource/help');
		return data;
	}
	
	async deleteHelp(helpId) {
		var results = await this.makeDELETERequest('/api/resource/help/' + helpId);
		return results;
	}	
	
	async saveHelp(help, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/help/' + help.helpId, help);
		} else {
			saved = await this.makePOSTRequest('/api/resource/help', help);
		}
		return saved;
	}
	
	async getHelpPage(page) {
		var data = await this.makeGETRequest('/api/resource/help/page/' + encodeURIComponent(page));
		return data;
	}

	exportHelp(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/help/export' + params);
	};

}
